import { render, staticRenderFns } from "./EatingOnABudget.vue?vue&type=template&id=6200649e&"
import script from "./EatingOnABudget.vue?vue&type=script&lang=js&"
export * from "./EatingOnABudget.vue?vue&type=script&lang=js&"
import style0 from "./EatingOnABudget.vue?vue&type=style&index=0&id=6200649e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports